import React from 'react';
import ServiceDetailTemplate from '../components/service/ServiceDetailTemplate';

function Seguros() {
    const data = {
        title: "Seguros",
        // Seguindo a sequência: /assets/images/novos/1/3.png
        mainImage: "/assets/images/novos/1/3.png",
        description1: "Proteção patrimonial completa e gestão de riscos personalizada para empresas e produtores rurais.",
        description2: "Garantimos a continuidade do seu negócio através de coberturas que protegem desde ativos físicos até a vida dos colaboradores.",
        cards: [
            // Mantendo o padrão de ícones: /assets/images/servicos/3/1.png
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Seguro Empresarial", 
                disc: "Proteção contra danos, lucros cessantes e responsabilidade civil." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Seguro Rural", 
                disc: "Cobertura de safra e proteção contra imprevistos climáticos." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Gestão de Riscos", 
                disc: "Consultoria para minimizar prejuízos e vulnerabilidades." 
            },
            { 
                icon: "/assets/images/servicos/3/1.png", 
                title: "Equipamentos", 
                disc: "Seguro para maquinário pesado, eletrônicos e frotas." 
            }
        ],
        processSteps: [
            { title: "Inventário", disc: "Mapeamento de todos os ativos e riscos do negócio." },
            { title: "Cotação", disc: "Busca pelas melhores taxas nas principais seguradoras." },
            { title: "Proteção", disc: "Implementação da apólice e suporte em sinistros." }
        ],
        benefitTitle: "Soluções em Proteção",
        benefitDisc: "Cuidamos do seu patrimônio com foco em:",
        benefits: [
            "Seguro Patrimonial Robusto",
            "Proteção de equipamentos agrícolas",
            "Gestão de seguros de vida e saúde",
            "Suporte técnico em regulação de sinistros"
        ]
    };

    return <ServiceDetailTemplate {...data} />;
}

export default Seguros;